export default __webpack_public_path__ + "static/media/inner.c0b14a43.mp4";